import { AuthContext } from "@harvestr-api/common";
import {
    gqlDiscovery,
    gqlGitlabIssueCreateWithoutDiscoveryInput
} from "@harvestr-api/models";
import { gitlabApiService } from "../services/gitlab-api.service";
import { gitlabWebhookService } from "../services/gitlab-webhook.service";

export const gitlabIssueFacade = {
    async createIssueAndRegisterWebhook(
        data: {
            harvestrIssue: gqlGitlabIssueCreateWithoutDiscoveryInput;
            discovery: Pick<gqlDiscovery, "id" | "title" | "clientId">;
            copyDiscoveryAttachments: boolean;
        },
        context: AuthContext
    ) {
        const fullHarvestrIssue = await gitlabApiService.createIssue(
            data,
            context
        );
        await gitlabWebhookService.registerWebhook(
            fullHarvestrIssue?.gitlabProjectId,
            fullHarvestrIssue?.gitlabProjectName || "",
            context
        );
        return fullHarvestrIssue;
    },
    async linkIssueAndRegisterWebhook(
        data: {
            harvestrIssue: gqlGitlabIssueCreateWithoutDiscoveryInput;
            discovery: Pick<gqlDiscovery, "id" | "title" | "clientId">;
            copyDiscoveryAttachments: boolean;
        },
        context: AuthContext
    ) {
        const fullHarvestrIssue = await gitlabApiService.linkIssue(
            data,
            context
        );
        await gitlabWebhookService.registerWebhook(
            fullHarvestrIssue?.gitlabProjectId,
            fullHarvestrIssue?.gitlabProjectName || "",
            context
        );
        return fullHarvestrIssue;
    }
};
